<template>
    <router-view/>
</template>

<script>
    export default {
        name: "HaberKategori"
    }
</script>

<style scoped>

</style>